import { BillingCycle, PlanType } from '@/features/common/pricing';

import type {
  IProductMetadata,
  ProductMetadataFeature,
} from '../entities/ProductMetadata';

import {
  ProductMetadataBuilder,
  PRODUCT_METADATA_FEATURES_BY_ORDER,
} from './ProductMetadataBuilder';

export class CustomProductMetadataBuilder extends ProductMetadataBuilder {
  getVirtualFeatures(): ProductMetadataFeature[] {
    return PRODUCT_METADATA_FEATURES_BY_ORDER;
  }

  override getName(): string {
    return 'Custom';
  }

  getIsMostPopular(): boolean {
    return false;
  }

  override build(): IProductMetadata {
    return {
      name: this.getName(),
      mostPopular: this.getIsMostPopular(),
      family: PlanType.Custom,
      isCustom: true,
      annualDiscount: 0,
      variants: {
        [BillingCycle.Monthly]: {
          id: '',
          name: this.getName(),
          price: 'contact-sales',
          isPriceFixed: false,
          fullCredits: 'unlimited',
          bulkCredits: 'unlimited',
          totalPrice: 0,
          features: this.getVirtualFeatures(),
        },
        [BillingCycle.Yearly]: {
          id: '',
          name: this.getName(),
          price: 'contact-sales',
          isPriceFixed: false,
          fullCredits: 'unlimited',
          bulkCredits: 'unlimited',
          totalPrice: 0,
          features: this.getVirtualFeatures(),
        },
      },
    };
  }
}
